import { MemoizedCarePlanInputProps } from ".";
import { ui } from "../../../interfaces/interfaces";
import { ServiceAgreementsInputs } from "@utils/BasicTypes";

type A11yProps = {
  (name: MemoizedCarePlanInputProps["inputName"], prefix: MemoizedCarePlanInputProps["prefix"]): {
    id: string;
    name: ServiceAgreementsInputs;
    fullWidth: boolean;
    autoComplete: string;
    "aria-controls": string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  };
};

export const a11yProps: A11yProps = (name, prefix) => ({
  id: `input-${name.toLowerCase()}`,
  name,
  fullWidth: true,
  autoComplete: "none",
  "aria-controls": `action-input-${name.toLowerCase()}`,
  onChange: handleChange,
});

export const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  const value = event.target.value;
  const name = event.target.name as ServiceAgreementsInputs;
  ui[name] = value as never;
};
